import React from 'react';
import livresImage from '../../images/collection1.jpg';
import CategoryPage from '../CategoryPage';

function LivresPage() {
    const details = [
        'Livres rares de collection',
        'Manuscrits anciens et éditions originales',
        'Ouvrages littéraires, historiques et scientifiques',
        'Trésors pour les passionnés de lecture et d’histoire',
    ];

    return (
        <CategoryPage
            title="Livres"
            image={livresImage}
            description="Explorez une collection unique de livres rares et manuscrits anciens, parfaits pour les amateurs de littérature et d'histoire."
            details={details}
        />
    );
}

export default LivresPage;
